<template>
  <div class="activities-overlay">
    <div class="top-bar">
      <button class="btn back-button" v-on:click="backClicked"><span></span></button>
      <button v-if="showStartedActivity && activitiesOfSelectedType.length > 1" class="btn carousel-button previous"
              @click="previousActivityClicked"></button>
      <div class="title-bar-wrapper">
        <div class="title-bar">
          <div class="icon" :class="questTypeOutlinedIconClass(getCurrentActivity?.quest?.type)"></div>
          <div class="title">{{ getCurrentActivity?.quest?.title }}</div>
        </div>
        <div v-if="showStartedActivity && activitiesOfSelectedType.length > 1" class="pips">
          <button class="pip btn" v-for="act in activitiesOfSelectedType"
                  :key="act.id"
                  :class="getCurrentActivity.id === act.id? 'large' : '' "
                  @click="pipClicked(act.id)"
          ></button>
        </div>
      </div>
      <button v-if="showStartedActivity && activitiesOfSelectedType.length > 1" class="btn carousel-button next"
              @click="nextActivityClicked"></button>
    </div>

    <transition appear name="bounce">
      <div v-show="open" class="activity-detail-wrapper">
        <div class="header-bar"></div>

        <ActivityDetail v-if="!showPlannedActivity && !showStartedActivity" :activity="getCurrentActivity"
                        :buddy="buddy" :showingRandomActivity="showingRandomActivity"
                        @randomActivityClicked="randomActivityClicked"
                        @startPhoneView="startPhoneView"></ActivityDetail>
        <PlannedActivity v-show="showPlannedActivity || showStartedActivity"
                         :open="open && (showPlannedActivity || showStartedActivity)" :activity="getCurrentActivity"
                         :buddy="buddy"
                         @startActivityClicked="startActivityClicked" @completeActivityClicked="completeActivityClicked"
                         @cancelActivityClicked="cancelActivityClicked"></PlannedActivity>

        <LeaveActivityPopup v-if="showLeaveActivityPopup" :open="showLeaveActivityPopup"
                            @closeClicked="showLeaveActivityPopup = false"
                            @confirmClicked="leaveActivityConfirmed"></LeaveActivityPopup>


        <div class="load-icon-view">
          <div class="load-icon">
            <LoadIcon :show="showLoadIcon"></LoadIcon>
          </div>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>

import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import ActivityDetail from "@/components/StudentPlatform/Activities/ActivityDetail";
import PlannedActivity from "@/components/StudentPlatform/Activities/PlannedActivity";
import { QuestApi, ActivityApi } from "sandpiper_api";
import log from "@/utils/logger";
import LeaveActivityPopup from "@/components/StudentPlatform/Activities/LeaveActivityPopup";
import LoadIcon from "@/components/StudentPlatform/LoadIcon";
import SoundPlayer from "@/utils/SoundPlayer";
import {Sound} from "@/enums/Sound";

export default {
  name: "ActivityDetailOverlay",
  components: { ActivityDetail, PlannedActivity, LeaveActivityPopup, LoadIcon },
  emits: [
    "startActivityClicked",
    "completeActivityClicked",
    "cancelActivityClicked",
    "backClicked",
    "startPhoneView",
    "randomActivityClicked"
  ],
  mixins: [ QuestTypeHelper ],
  inject: [ "doApiRequest" ],
  props: {
    name: String,
    open: Boolean,
    activityId: Number,
    buddy: Object,
    questType: String,
    startedActivities: Array,
    showPlannedActivity: Boolean,
    showStartedActivity: Boolean,
    showingRandomActivity: Boolean,
  },
  watch: {
    open: {
      handler()
      {
        if (this.open)
        {
          SoundPlayer.playMusic(Sound.BABAYETU);
          if (!this.showStartedActivity)
          {
            this.startedActivityIndex = 0;
            this.setActivity(this.activityId);
          }
        }
        else
        {
          this.startedActivityIndex = 0;
        }
      },
      deep: true,
    },
    showStartedActivity: {
      handler()
      {
        if (this.showStartedActivity === true)
        {
          this.activity = this.startedActivitiesInverted[0];
        }

      },
      deep: true,
    }
  },
  data()
  {
    return {
      show: this.open,
      activity: {
        questProperties: {},
      },
      showLeaveActivityPopup: false,
      showLoadIcon: false,
      startedActivityIndex: 0,
      leaveIntent: "",
    }
  },
  computed: {

    getCurrentActivity()
    {
      //console.log("[ADO] Getting current activity");
      let id = null;

      //console.log("[ADO] showStartedActivity = " + this.showStartedActivity);
      if (this.showStartedActivity)
      {
        if (this.activitiesOfSelectedType.length > 0 && this.activitiesOfSelectedType[this.startedActivityIndex] !== undefined)
        {
          id = this.activitiesOfSelectedType[this.startedActivityIndex].id;
        }
        else
        {
          log.info("No activities of selected type found")
        }
      }
      else
      {
        //console.log("[ADO] setting id to " + this.activityId);
        id = this.activityId;
      }


      if (id !== null && id !== undefined)
      {
        if (this.showStartedActivity)
        {
          //console.log("[ADO] id is not null, showStartedActivity is true");
          //console.log(this.startedActivitiesInverted)
          let activity = this.startedActivitiesInverted.find(activity => activity.id === id);
          if (activity !== null && activity !== undefined)
          {
            return activity;
          }
          else
          {
            log.info("act was null or undefined")
            return null;
          }
        }
        else
        {
          return this.activity;
        }
      }
      else
      {
        return null;
      }


    },
    activitiesOfSelectedType()
    {
      let questType = this.questType;
      log.info("finding activities of type " + this.questType)
      let activitiesOfType = [];
      log.info(this.startedActivitiesInverted);
      this.startedActivitiesInverted.forEach(activity =>
      {
        if (activity.quest.type === questType)
        {
          activitiesOfType.push(activity);
        }
      });

      return activitiesOfType;
    },
    startedActivitiesInverted() {
      return this.startedActivities.toReversed();
    }


  },
  methods: {

    async fetchActivity(id)
    {
      try
      {
        this.fetchingActivity = true;
        this.showLoadIcon = true;
        log.info("fetching activity with " + id);

        const response = await this.doApiRequest(() => new ActivityApi().getActivity(id));

        log.info("Fetch activity response: %o", response);
        return response;
      }
      catch (e)
      {
        log.info(e);
        return null;
        // TODO - handle exception
      }
      finally
      {
        this.showLoadIcon = false;
        this.fetchingActivity = false;
      }
    },

    async fetchQuest(id)
    {
      try
      {
        this.fetchingActivity = true;
        log.info("fetching activity with " + id)
        const response = await this.doApiRequest(() => new QuestApi().getQuest(id));

        log.info("Fetch activity response: %o", response);
        return response;
      }
      catch (e)
      {
        log.info(e);
        return null;
        // TODO - handle exception
      }
      finally
      {
        this.fetchingActivity = false;
      }
    },

    async setActivity(id)
    {
      if (this.showPlannedActivity)
      {
        this.activity = await this.fetchActivity(id);
      }
      else
      {
        let actWrapper = {};
        actWrapper.quest = await this.fetchQuest(id);
        this.activity = actWrapper;
      }
    },

    backClicked()
    {
      SoundPlayer.stopMusic();
      if (this.showStartedActivity && this.getCurrentActivity.quest.format === 'quiz')
      {
        this.leaveIntent = "back";
        this.showLeavePopup();
      }
      else
      {
        if (this.getCurrentActivity.quest.type === 'impulse') {
          this.backConfirmed(true);
        } else {
          this.backConfirmed(false);
        }
      }
    },

    startPhoneView(id)
    {
      this.$emit("startPhoneView", id, "detailOverlay");
    },

    startActivityClicked(data)
    {
      this.$emit("startActivityClicked", data);
    },

    completeActivityClicked(data)
    {
      data.activity = this.getCurrentActivity;
      this.$emit("completeActivityClicked", data);
    },

    cancelActivityClicked(id)
    {
      this.$emit("cancelActivityClicked", id);
    },

    previousActivityClicked()
    {
      if (this.showStartedActivity && this.getCurrentActivity.quest.format === 'quiz')
      {
        this.leaveIntent = "previous";
        this.showLeavePopup();
      }
      else
      {
        this.previousActivityConfirmed();
      }
    },

    previousActivityConfirmed()
    {
      if (this.startedActivityIndex <= 0)
      {
        this.startedActivityIndex = this.activitiesOfSelectedType.length - 1;
      }
      else
      {
        this.startedActivityIndex--;
      }
    },
 
    nextActivityClicked()
    {
      if (this.showStartedActivity && this.getCurrentActivity.quest.format === 'quiz')
      {
        this.leaveIntent = "next";
        this.showLeavePopup();
      }
      else
      {
        this.nextActivityConfirmed();
      }
    },

    nextActivityConfirmed()
    {
      if (this.startedActivityIndex >= this.activitiesOfSelectedType.length - 1)
      {
        this.startedActivityIndex = 0;
      }
      else
      {
        this.startedActivityIndex++;
      }
    },

    backConfirmed(fromImpulseActivityContent)
    {
      this.$emit("backClicked", fromImpulseActivityContent);
    },

    showLeavePopup()
    {
      this.showLeaveActivityPopup = true;
    },

    leaveActivityConfirmed()
    {
      switch (this.leaveIntent)
      {
        case "previous":
          this.previousActivityConfirmed();
          break;
        case "next":
          this.nextActivityConfirmed();
          break;
        case "back":
          this.backConfirmed();
          break;
      }

      this.showLeaveActivityPopup = false;
    },

    pipClicked(id)
    {
      let activity = this.activitiesOfSelectedType.find(act => act.id === id);
      this.startedActivityIndex = this.activitiesOfSelectedType.indexOf(activity);
    },

    randomActivityClicked(id, isRandom)
    {
      this.$emit("randomActivityClicked", id, isRandom);
    }

  }
}


</script>

<style lang="scss" scoped>

@mixin aspect-ratio($width, $height) {
  position: relative;
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: ($height / $width) * 100%;
  }
  > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.activities-overlay {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: rgb(37, 38, 66);
  z-index: 9999;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.top-bar {
  height: 150px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.activity-detail-wrapper {
  height: calc(100vh - 150px);
  width: 100%;
  overflow: hidden;
  background-image: url("~@/assets/image/platform/background/activity_bg.svg");


  .header-bar {
    width: 100%;
    background-image: url("~@/assets/image/platform/background/activity_border.svg");
    background-repeat: no-repeat;
    background-size: 100vw;
    background-position: top center;
    padding-top: 6%;
    pointer-events: none;

    position: absolute;
    z-index: 2;
  }
}

.back-button {
  width: 100px;
  height: 100px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50px;
  top: 25px;
  background-image: url("~@/assets/image/button/bb_button_square.svg");

  span {
    display: block;
    width: 70%;
    height: 70%;
    background-image: $back-icon;
    background-position: center;
    background-size: contain;
  }

}

.title-bar-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.title-bar {
  min-height: 67%;
  width: 600px;
  margin-bottom: 15px;
  position: relative;
  background-image: url("~@/assets/image/bb_frame-title.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;

  display: flex;
  align-items: center;


  .icon {
    position: absolute;
    width: 60px;
    height: 60px;
    left: 20px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .title {
    align-self: center;
    margin: 0px 100px;
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
    color: white;
  }
}

.pips {
  position: absolute;
  align-self: center;
  justify-self: flex-end;
  bottom: 5px;
  display: flex;
  justify-content: center;
  align-items: center;


  .pip {
    width: 10px;
    height: 10px;
    padding: 0px;
    border-radius: 10px;
    background-color: white;
    margin: 5px;

    &.large {
      width: 15px;
      height: 15px;
    }
  }
}

.carousel-button {
  margin-bottom: 15px;
  background-image: url("~@/assets/image/icons/icon-arrow.svg");

  width: 40px;
  height: 40px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  align-self: center;

  &.previous {
    margin-right: 50px;
    transform: rotate(90deg);
  }

  &.next {
    margin-left: 50px;
    transform: rotate(270deg);
  }
}

.bounce-enter-active {
  animation: bounce-in 1s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translateY(100vh);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(0);
  }
}

.load-icon-view {
  pointer-events: none;
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;

  .load-icon {
    width: 200px;
    height: 200px;
  }
}

</style>